import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { LeavePermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[],
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Leaves route page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page) }
}

/** Admin leave routes under /admin/leaves. */
export const leaveRoutes: RouteObject[] = [
  {
    path: 'admin/leaves',
    lazy: () =>
      lazyGuardedRoute(() => import('./pages/leaves-board-page'), 'LeavesBoardPage', LeavePermissions.access),
  },
  {
    path: 'admin/leaves/policies',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/leave-policies-page'),
        'LeavePoliciesPage',
        [LeavePermissions.managePolicies, LeavePermissions.manage],
      ),
  },
  {
    path: 'admin/leaves/employees/:employeeId',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/employee-leaves-page'),
        'EmployeeLeavesPage',
        LeavePermissions.access,
      ),
  },
]
